const thStyle = {
  padding: "10px 12px",
  fontSize: "0.7rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  color: "#9e9e9e",
  background: "#f8f9fb",
  borderBottom: "1px solid #f0f0f0",
  whiteSpace: "nowrap",
};

const PositionRowHeader = ({ showDropdowns = true }) => (
  <thead>
    <tr>
      <th style={{ ...thStyle, width: "36px", textAlign: "center" }}>#</th>
      <th style={{ ...thStyle }}>Description</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Price</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Qty</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Tax %</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Net</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Tax €</th>
      <th style={{ ...thStyle, textAlign: "right" }}>Gross</th>
      {showDropdowns && <th style={{ ...thStyle, width: "40px" }} />}
    </tr>
  </thead>
);

export default PositionRowHeader;
